export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getLocations>
        <countryId>${params.countryId}</countryId>
        <cityCode>${params.cityCode}</cityCode>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getLocations>
    </soapenv:Body>
  </soapenv:Envelope>
`
